export const HROBY_PUBLIC = [
  { id: "kolumbarium", nazev: "Kolumbárium" },
  { id: "urnovy_hrob", nazev: "Urnový hrob" },
  { id: "jednohrob", nazev: "Jednohrob" },
  { id: "dvouhrob", nazev: "Dvouhrob" },
  { id: "hrobka", nazev: "Hrobka" },
];

export const LIMITY_KVETINY = [
  { id: "bez", label: "Bez květin", castka: 0 },
  { id: "do_200", label: "Do 200 Kč", castka: 200 },
  { id: "do_300", label: "Do 300 Kč", castka: 300 },
  { id: "do_500", label: "Do 500 Kč", castka: 500 },
  { id: "do_800", label: "Do 800 Kč", castka: 800 },
  { id: "vlastni", label: "Vlastní částka", castka: 0 },
];

export const LIMITY_DEKORACE = [
  { id: "bez", label: "Bez dekorace", castka: 0 },
  { id: "do_200", label: "Do 200 Kč", castka: 200 },
  { id: "do_300", label: "Do 300 Kč", castka: 300 },
  { id: "do_500", label: "Do 500 Kč", castka: 500 },
  { id: "do_800", label: "Do 800 Kč", castka: 800 },
  { id: "vlastni", label: "Vlastní částka", castka: 0 },
];

export const DOPLNKY_PUBLIC = [
  {
    id: "uklid_okoli",
    nazev: "Úklid okolí hrobu",
    popis: "Zametání, odstranění drobných nečistot a základní srovnání okolí.",
    cenaBezDph: 0,
    dph: 21,
    typCeny: "v_cene",
  },
  {
    id: "myti_desky_od",
    nazev: "Mytí náhrobní desky",
    popis: "Omytí povrchu náhrobní desky podle rozsahu znečištění.",
    cenaBezDph: 285,
    dph: 21,
    typCeny: "od",
  },
  {
    id: "zapalení_svicky",
    nazev: "Zapálení svíčky",
    popis: "Zapálení svíčky a základní kontrola pietního místa.",
    cenaBezDph: 142,
    dph: 21,
    typCeny: "fix",
  },
  {
    id: "vysadba_kvetin",
    nazev: "Výsadba květin",
    popis: "Výsadba květin podle sezóny a dostupnosti, cena se řídí zvoleným limitem.",
    cenaBezDph: 276,
    dph: 21,
    typCeny: "od_plus_limit",
  },
  {
    id: "dekorace",
    nazev: "Dekorace na hrob",
    popis: "Doplnění dekorací podle sezóny a přání zákazníka, cena se řídí zvoleným limitem.",
    cenaBezDph: 0,
    dph: 21,
    typCeny: "limit",
  },
  {
    id: "fotodokumentace",
    nazev: "Fotodokumentace",
    popis: "Fotografie před a po provedení údržby.",
    cenaBezDph: 0,
    dph: 21,
    typCeny: "fix",
  },
  {
    id: "jiny_pozadavek",
    nazev: "Jiný požadavek",
    popis: "Individuální požadavek podle poznámky v objednávce.",
    cenaBezDph: 0,
    dph: 21,
    typCeny: "individual",
  },
];

export const HLAVNI_SLUZBY_PUBLIC = [
  {
    id: "jednorazove_cisteni",
    nazev: "Jednorázové čištění",
    popis:
      "Jednorázové očištění a úprava hrobového místa. Vhodné před svátky, výročím nebo při běžné potřebě údržby.",
    obsah:
      "Obsah: základní očištění hrobu, srovnání dekorací na místě, běžný úklid okolí",
    ceny: {
      kolumbarium: 276,
      urnovy_hrob: 370,
      jednohrob: 466,
      dvouhrob: 655,
      hrobka: 1226,
    },
  },
  {
    id: "pravidelna_pece",
    nazev: "Pravidelná péče",
    popis:
      "Průběžná péče o hrob v pravidelném režimu. Vhodné pro zákazníky, kteří chtějí dlouhodobě udržovaný hrob.",
    obsah:
      "Obsah: pravidelný úklid, kontrola stavu hrobu, možnost doplnění služeb ke každé návštěvě",
    ceny: {
      kolumbarium: 276,
      urnovy_hrob: 370,
      jednohrob: 466,
      dvouhrob: 655,
      hrobka: 1226,
    },
  },
  {
    id: "balicek_4_plus_1",
    nazev: "Základní péče o hrob – 4 návštěvy + 5. zdarma",
    popis:
      "Roční balíček péče. Obsahuje 4 placené návštěvy a 2 bonusové návštěvy zdarma. Každý termín může mít vlastní rozsah prací.",
    obsah:
      "Obsah: 4 účtované návštěvy během roku, 5. bonusová návštěva zdarma, možnost rozdělení podle významných dnů, 6. bonusová návštěva zdarma, u každého termínu lze zvolit doplňky zvlášť",
    ceny: {
      kolumbarium: 913,
      urnovy_hrob: 1226,
      jednohrob: 1543,
      dvouhrob: 2168,
      hrobka: 4058,
    },
  },
  {
    id: "obnova_hrobu",
    nazev: "Obnova hrobu",
    popis:
      "Kompletnější zásah podle stavu hrobu. Přesná cena bude potvrzena po posouzení rozsahu prací.",
    obsah:
      "Obsah: hlubší očištění, obnova vzhledu hrobu, individuální nacenění dle stavu",
    ceny: {},
  },
  {
    id: "individualni_poptavka",
    nazev: "Individuální poptávka",
    popis:
      "Použijte v případě, že potřebujete specifický rozsah prací mimo standardní nabídku.",
    obsah:
      "Obsah: individuální posouzení, návrh řešení podle požadavku, cena bude potvrzena následně",
    ceny: {},
  },
];

export function formatCena(cena) {
  const n = Number(cena || 0);
  return `${n.toLocaleString("cs-CZ")} Kč`;
}

export function getHlavniSluzbaById(id) {
  return HLAVNI_SLUZBY_PUBLIC.find((x) => x.id === id) || null;
}

export function getDoplnekById(id) {
  return DOPLNKY_PUBLIC.find((x) => x.id === id) || null;
}

export function getZakladniCenu(sluzbaId, typHrobu) {
  const sluzba = getHlavniSluzbaById(sluzbaId);
  if (!sluzba) return 0;
  const ceny = sluzba.ceny || sluzba.cenyOd || {};
  return Number(ceny?.[typHrobu] || 0);
}
